// bao migrate skip
import "./../../services/bao-router";
import "./../../bindings/bao-searcher";
import * as ko from "knockout";
import Bao from "./../../services/bao-service";
import BaoDialogViewModel from "./../../factories/bao-dialog";
import baoRouter from "./../../services/bao-router";
import StringUtils from "../../services/bao-utils";

class AbsentDaysForShiftGroupGanttReportViewModel {
    constructor(parent: any) {
        this.parent = parent;
        this._initialized = false;
    }
    parent: any;
    Bao = Bao;
    private _initialized: boolean;
    ShiftGroupId: KnockoutObservable<string> = ko.observable("");
    ShiftGroupName: KnockoutObservable<string> = ko.observable("");
    Years: KnockoutObservableArray<number> = ko.observableArray([]);
    SelectedYear: KnockoutObservable<number> = ko.observable(null);
    HolidayGanttDataForShiftGroup: KnockoutObservableArray<any> = ko.observableArray([]);
    /** true if the report has loaded data, false otherwise
     */
    ReportLoaded: KnockoutObservable<boolean> = ko.observable(false);
    /** true if the report has loaded at least once
     */
    ReportRequested: KnockoutObservable<boolean> = ko.observable(false);
    /** true if the report has loaded and no data are available, false otherwise
     */
    IsReportResultEmpty: KnockoutComputed<boolean> = ko.pureComputed(() => { return (this.ReportLoaded() === false) && this.ReportRequested(); });
    Download() {
        if (StringUtils.String.IsNullOrWhitespace(this.ShiftGroupId()) || this.SelectedYear() == null) {
            new BaoDialogViewModel(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgFillMandatorFields"), "info");
        }
        else {
            this.parent.TabPage.IsLoading(true);
            Bao.post("SynosetReportCenter/AbsentDaysForShiftGroupGanttReportDownload", JSON.stringify({
                shiftGroupId: this.ShiftGroupId(),
                year: this.SelectedYear(),
                reportTemplateId: null
            }), (result) => {
                this.parent.TabPage.IsLoading(false);
                if (result.Result == true) {
                    baoRouter.setHash("document/" + result.Message);
                }
            });
        }
    }
    GetReport() {
        if (StringUtils.String.IsNullOrWhitespace(this.ShiftGroupId()) || this.SelectedYear() == null) {
            new BaoDialogViewModel(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgFillMandatorFields"), "info");
        }
        else {
            this.ReportLoaded(false);
            this.parent.TabPage.IsLoading(true);
            Bao.post("SynosetReportCenter/AbsentDaysForShiftGroupGanttReportGetReport", JSON.stringify({
                shiftGroupId: this.ShiftGroupId(),
                year: this.SelectedYear(),
                reportTemplateId: null
            }), (result) => {
                if (result.Result) {
                    this.HolidayGanttDataForShiftGroup(result.Value);
                    this.ReportLoaded(true);
                }
                this.parent.TabPage.IsLoading(false);
                this.ReportRequested(true);
            });
        }
    }
    getDaysOfTheYear() {
        return this.isLeapYear() ? 366 : 365;
    }
    isLeapYear() {
        return this.SelectedYear() % 400 === 0 || (this.SelectedYear() % 100 !== 0 && this.SelectedYear() % 4 === 0);
    }
    getDayOfTheYear(dateAsString: string): number {
        var date: any = new Date(dateAsString);
        var start: any = new Date(date.getFullYear(), 0, 0);
        var diff = (date - start) + ((start.getTimezoneOffset() - date.getTimezoneOffset()) * 60 * 1000);
        var oneDay = 1000 * 60 * 60 * 24;
        return Math.floor(diff / oneDay);
    }
    init() {
        return Bao.post("SynosetReportCenter/AbsentDaysForShiftGroupGanttReportGetDefaultData", (result) => {
            ko.map.fromJS(result, this);
            this._initialized = true;
        });
    }
    ;
    loaded() {
        //Dashboard laden
        var currentDate = new Date();
    }
    ;
}
export default AbsentDaysForShiftGroupGanttReportViewModel;